<!-- IF PATRON IS LOGGED WITH OKTA, SHOW IT -->
<div class="flex md:flex-row flex-col gap-y-7 mb-3 px-6 py-4 box-white">
  <!-- ACCOUNT CREDIT COLUMN-->
  <div class="flex flex-col w-full md:w-1/2 account-credit-col">
    <div class="title">Account Credit</div>
    <div class="mb-2 md:mb-5 sub-title">
      <b
        >Your account’s available credit:
        {{ patron.accountCredit | currency: 'USD' : 'symbol' : '1.2-2' }}</b
      ><br />
      Please select the amount you would like to use:
    </div>
    <div
      class="flex md:flex-row flex-col items-baseline md:items-center gap-y-2 w-full">
      <div class="flex justify-center items-center gap-x-3 mr-5 w-full">
        <span class="flex justify-center items-center">$</span>
        <input
          type="text"
          value="0"
          class="flex selector-filter"
          (blur)="onBlurInputCredits()"
          [(ngModel)]="paymentDetails.accountCredit.credits" />
      </div>
      <div class="flex gap-x-4">
        <input
          type="checkbox"
          name="payInFull"
          [(ngModel)]="paymentDetails.accountCredit.payFull"
          (change)="onCheckboxPayInFullChange($event)" />
        <span>Use all available credit</span>
      </div>
    </div>
  </div>
  <!-- DIGITAL WALLET COLUMN-->
  <div class="flex flex-col md:ml-10 w-full md:w-1/2 digital-wallet-col">
    <div class="title">Payment Options</div>
    <div class="mb-5 sub-title">
      <b
        >Total amount due:
        {{
          transaction.transaction.tdcTransaction?.balance
            | currency: 'USD' : 'symbol' : '1.2-2'
        }}</b
      >
      <br />
      Credit applied:
      {{ showCreditsApplies | currency: 'USD' : 'symbol' : '1.2-2' }}
      <br />
      Remaining balance:
      {{ substractCreditsToBalance | currency: 'USD' : 'symbol' : '1.2-2' }}
      <br />
      Please select the digital wallet card you would like to use:
    </div>
    <div>
      <select
        [(ngModel)]="paymentDetails.digitalWallet"
        (change)="onChangeDigitalWalletSelector()"
        name="digitalWallet"
        class="w-full selector-filter">
        <option [ngValue]="null">Select your Digital wallet</option>
        @for (item of patron.digitalWalletList; track item.id) {
          <option [ngValue]="item">
            {{ item.nickname }}
          </option>
        }
      </select>
    </div>
    <!-- <div class="mt-5">
      <button
        type="button"
        class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-main"
        (click)="onAddDigitalWallet()">
        Add Credit Card
      </button>
    </div> -->
  </div>
</div>
